<div class="display-info-wrapper">
  <div id="toolbar"></div>
  <div class="display-info">
    <div class="display-info-editor">
      <ngx-editor [message]="description" [maxCharacterLimit]="contentSizeLimit" (valueChange)="update($event)"></ngx-editor>
    </div>
  </div>
</div>
